export enum ActionType {

    SHOW_ERROR,
    RESET_ERROR

}
